export default __webpack_public_path__ + "media/images/community/background-dark-27096fb6812a819d1613f61214f7a18f.svg";